import { defineStore } from 'pinia'

export const useEstimateStore = defineStore('estimate', {
    state: () => ({
        estimate_list:[],
        select_list:[],
        select_wholesaler_ids:[],
    }),
    actions: {
        reset_data() {
            this.estimate_list.splice(0);
            this.select_list.splice(0);
            this.select_wholesaler_ids.splice(0);
        },
        reset_select_data() {
            this.select_list.splice(0);
            this.select_wholesaler_ids.splice(0);
        },
        is_edited() {
            let result = false;
            if (this.estimate_list.length > 0) {
                result = true;
            }
            if (this.select_list.length > 0) {
                result = true;
            }
            return result;
        },
    },
    persist: true,
})
